import { render, staticRenderFns } from "./ProductFamilyManager.vue?vue&type=template&id=70fdf3a6&scoped=true&"
import script from "./ProductFamilyManager.vue?vue&type=script&lang=js&"
export * from "./ProductFamilyManager.vue?vue&type=script&lang=js&"
import style0 from "./ProductFamilyManager.vue?vue&type=style&index=0&id=70fdf3a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fdf3a6",
  null
  
)

export default component.exports